'use client';

import Image from 'next/image';
import Link from 'next/link';
import dynamic from 'next/dynamic';
import { ActionIcon } from '@mantine/core';
import { IconSettings } from '@tabler/icons-react';
import { usePathname } from 'next/navigation';
import NavLinkItem from './NavLinkItem';

const RenderMenu = dynamic(() => import('./RenderMenu'), {
  ssr: false,
});

const LINKS = [
  { href: '/device', label: 'device' },
] as const;

export default function Nav() {
  const pathname = usePathname();
  const isSettingsPage = pathname === '/settings';
  const isPuppyPage = pathname === '/';

  return (
    <nav
      style={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: '0.25rem',
        padding: '0 0.75rem',
        background: '#23262f',
      }}
    >
      <Link
        href="/"
        aria-label="Go home"
        style={{
          display: 'flex',
          alignItems: 'center',
          marginRight: '0.5rem',
          flexShrink: 0,
        }}
      >
        <Image src="/logo.png" alt="Home" width={28} height={28} priority />
      </Link>

      {LINKS.map((link) => (
        <NavLinkItem
          key={link.href}
          href={link.href}
          label={link.label}
          active={pathname === link.href}
        />
      ))}

      <div
        style={{
          marginLeft: 'auto',
          display: 'flex',
          alignItems: 'center',
          gap: '0.25rem',
        }}
      >
        <ActionIcon
          component={Link}
          href="/settings"
          variant="subtle"
          size="lg"
          radius="md"
          aria-label="Open settings"
          style={{
            color: isSettingsPage ? '#ffffff' : '#ebe6e6',
            background: isSettingsPage ? '#ebe6e611' : 'transparent',
          }}
        >
          <IconSettings size={18} stroke={1.75} />
        </ActionIcon>

        {isPuppyPage ? <RenderMenu /> : null}
      </div>
    </nav>
  );
}
